"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeParam = void 0;
function isTypeParam(t) {
    return ((Array.isArray(t) &&
        t.length === 1 &&
        typeof t[0] === "symbol") || typeof t === "symbol");
}
exports.isTypeParam = isTypeParam;
